import axios, { AxiosError } from "axios";
import { COMMON_STRINGS } from "../constants/strings";

// 🔐 Base URL
//const BASE_URL = "http://localhost:3012/api";
const BASE_URL = "https://api.ssquarelogic.com/api";
//const BASE_URL = process.env.REACT_APP_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
});

// ================= REQUEST INTERCEPTOR =================

// 🔐 Attach token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// ================= RESPONSE INTERCEPTOR =================

axiosInstance.interceptors.response.use(
  (response) => response,

  (error: AxiosError<any>) => {
    const status = error.response?.status;
    const serverMessage = error.response?.data?.message;
    const shouldLogout = error.response?.data?.logout;

    // 🔥 Common logout function
    const handleLogout = () => {
      localStorage.removeItem("token");

      // 🔥 optional: clear redux (best way)
      window.dispatchEvent(new Event("logout"));

      // 🔥 correct redirect
      window.location.href = "/";
    };

    // 🔥 FORCE LOGOUT
    if (status === 403 && shouldLogout) {
      console.warn("🚫 Forced logout triggered");
      handleLogout();

      return Promise.reject({
        success: false,
        message: "Unauthorized admin access",
        status,
      });
    }

    // 🔥 Default message
    let finalMessage =
      error.response?.data?.msg ||
      error.response?.data?.message ||
      COMMON_STRINGS.SERVER_ERROR;

    // 🔐 Unauthorized
    if (status === 401) {
      finalMessage = COMMON_STRINGS.UNAUTHORIZED;
      handleLogout();
    }

    // 🚫 Forbidden
    if (status === 403) {
      finalMessage =
        error.response?.data?.msg ||
        error.response?.data?.message ||
        COMMON_STRINGS.FORBIDDEN;
    }

    // ❌ Not found
    if (status === 404) {
      finalMessage = COMMON_STRINGS.NOT_FOUND;
    }

    // ⚠️ Server error
    if (status === 500) {
      finalMessage = COMMON_STRINGS.SERVER_ERROR;
    }

    // 🌐 Network error
    if (!error.response) {
      finalMessage = COMMON_STRINGS.NETWORK_ERROR;
    }

    return Promise.reject({
      success: false,
      message: finalMessage,
      msg: finalMessage,
      status,
      originalError: error,
    });
  },
);

export default axiosInstance;
